import { render, staticRenderFns } from "./PaginationBar.vue?vue&type=template&id=38e77e6a"
import script from "./PaginationBar.vue?vue&type=script&lang=ts"
export * from "./PaginationBar.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports